export default __webpack_public_path__ + "static/media/R-PANELv6.5-RC1/zonademand_MX_mobile.ddec7618.png";